import { Injectable } from '@angular/core';
import {environment} from '@env/environment';


@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private customer = environment.customer;

    constructor() { }

    static checkIsAmplifyCustomer(): boolean {
        return environment.customer.theme == 'amplify';
    }

    static checkIsSupportSsoAppFeature(): boolean {
        return environment.customer?.features?.ssoApp;
    }

    static checkIsSupportOnboardingWizardFeature(): boolean {
        return environment.customer?.features?.onboardingWizard;
    }

    static checkIsSupportAnyDataAnywhereFeature(): boolean {
        return environment.customer?.features?.anyDataAnywhere;
    }

    static getPIIServiceLink(): string {
        return `${environment.etxBaseURI}/oauth/auth?client_id=PTRMETZWZL&redirect_uri=https%3A%2F%2Fshield.schoolpassport.net%2Flogin%2Fgg4l&response_type=code`;
    }
}
